// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__3YfIj","App-logo-spin":"Spinner_App-logo-spin__1H8Gv"};